<template>
  <div class="before-page-wrap">
    <page-header />
    <div class="conversation" id="before-page-message-box">
      <div class="message-box">
        <questions-type />
        <before-page-chat-item
          v-for="(item, index) in questionsMessage"
          v-show="index === questionsMessage.length - 1"
          :key="index"
          :item="item"
        />
      </div>
    </div>
    <uploadImg-model />
  </div>
</template>

<script>
import constant from "../../../../constant";
import pageHeader from "../components/page-header";
import questionsType from "../components/questions-type";
import beforePageChatItem from "../components/before-page-chat-item";
import uploadImgModel from "../components/uploadImg-model";
import globalUtils from "../../../../utils";
// import dbIndexed from "src/app/customer/utils/dbIndexed"
export default {
  name: "before-page",
  components: { pageHeader, questionsType, beforePageChatItem, uploadImgModel },
  computed: {
    ...mapState(["urlData"]),
    ...mapGetters(["messages"]),
    questionsMessage() {
      //过滤出技能组信息
      return this.messages.filter(s => s.type == constant.MESSAGE_TYPE.MT_QU);
    }
  },
  data() {
    return {
      time: null,
      number: 1
    };
  },
  methods: {
    getdeviceCode() {
      return globalUtils.getUUID();
    },
    disableBrowserBack() {
      history.pushState(null, null, document.URL);
    },
    scrollBottom() {
      this.$nextTick(() => {
        const beforePageMessageBox = document.querySelector(
          "#before-page-message-box"
        );
        clearTimeout(this.time);
        this.time = setTimeout(() => {
          beforePageMessageBox.scrollTop =
            beforePageMessageBox.children[0].scrollHeight;
        }, 100);
      });
    }
  },
  mounted() {
    this.scrollBottom();
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", this.disableBrowserBack);
  },
  destroyed() {
    window.removeEventListener("popstate", this.disableBrowserBack, false);
    clearTimeout(this.time);
  },
  watch: {
    messages() {
      this.scrollBottom();
    }
  },
  created() {
    this.$store.commit("clearAllMessages");
    //初始化状态 解决用户后退问题
    this.$store.commit("setState", {
      isQueue: false,
      isBeforeConnect: true,
      blackFlag: 0,
      isConversation: false,
      isUploadImg: false,
      isShowEvaluatePage: false
    });
  }
};
</script>
<style scoped lang="less">
.before-page-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;

  .conversation {
    position: relative;
    -webkit-overflow-scrolling: touch;
    flex: 1;
    padding: 15px 15px 0;
    flex-direction: column;
    overflow-y: auto;
    box-sizing: border-box;
    .message-box {
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
    }
  }
}
</style>
